<!-- Special Access Alert Panel -->
<div class="overLayDiv active" *ngIf="show"></div>
<div id="rightSideBar" *ngIf="show">
    <div class="rightSidePanel d-flex flex-column">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ 'self_setup_16_msg_22' | translate }}</h2>
            </div>
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body-with-footer">
            <div class="block mt-2" >
                <h6 class="info-text">
                    <span>{{ 'self_setup_16_msg_1' | translate }}</span>
                </h6>
                <h6 class="info-text">
                    <i class="fas fa-exclamation-circle eod-text-danger"></i>
                    <span>{{ 'self_setup_16_msg_2' | translate }}</span>
                </h6>
                <h6 class="note mb-2">{{ 'self_setup_16_msg_3' | translate }}</h6>
                <h6 class="info-text pb-0 border-0">
                    <i class="fas fa-check-circle eod-text-success"></i>
                    <span>{{ 'self_setup_16_msg_4' | translate }}
                    <a class="eod-link-primary px-1" (click)="fnHandleLinkClick('quick-change'); $event.preventDefault();">{{ 'self_setup_16_msg_5' | translate }}</a></span>
                </h6>
                <h6 class="info-text">
                    <i class="fas fa-check-circle eod-text-success"></i>
                    <span>
                        <span class="pr-1">{{ 'self_setup_16_msg_6' | translate }}</span>
                        <span>{{ 'self_setup_16_msg_7' | translate }}
                            <a class="eod-link-primary px-1" (click)="fnHandleLinkClick('wizard'); $event.preventDefault();">{{ 'self_setup_16_msg_8' | translate }}</a>
                        </span>
                    </span>
                </h6>
            </div>
        </div>
    </div>
</div>

<!-- Mileage Rate Setting Panel -->
<uk-mileage-rate-setting-panel 
    *ngIf="showEditMileageRate" 
    [formData]="MileageRateFormData"
    (closePanelEvent)="fnCloseQuickPanel($event)" 
    [PanelData]="setupMileageRatePanel">
</uk-mileage-rate-setting-panel>

<!-- Receipt Type Setup Panel -->
<app-manage-vat-steps 
    *ngIf="showReceiptTypeSetup"
    [panelHeading]="'Receipt Type Setup'"  
    [stepNum]="3" 
    [backBtnText]="'close'" 
    [vatNoVatReceiptDetails]="vatNoVatReceiptDetails"
    (closePanelEvent)="fnCloseQuickPanel($event)">  
</app-manage-vat-steps>
